import { isColdTub } from "../../utils/brand";

export enum HeatCycle {
    IDLE = 0,
    PUMPING = 1,
    HEATING = 2,
    COOLDOWN = 3,
}

export const HeatCycleTextMap: Record<HeatCycle, string> = {
    [HeatCycle.IDLE]: 'Idle',
    [HeatCycle.PUMPING]: 'Warm-Up',
    [HeatCycle.HEATING]: 'Heating',
    [HeatCycle.COOLDOWN]: 'Cool-Down',
};

export const HeatCycleStyleMap: Record<HeatCycle, string> = {
    [HeatCycle.IDLE]: 'idle',
    [HeatCycle.PUMPING]: 'preheat',
    [HeatCycle.HEATING]: 'heating',
    [HeatCycle.COOLDOWN]: 'cooldown',
};

export enum CoolingCycle {
    IDLE = 0,
    PRIMING = 1,
    HEATING = 2,
    COOLDOWN = 3,
    CHILLING = 4,
}

export const CoolingCycleTextMap: Record<CoolingCycle, string> = {
    [CoolingCycle.IDLE]: 'Idle',
    [CoolingCycle.PRIMING]: 'Priming',
    [CoolingCycle.HEATING]: 'Heating',
    [CoolingCycle.COOLDOWN]: 'Cool-Down',
    [CoolingCycle.CHILLING]: 'Chilling',
};

export const CoolingCycleStyleMap: Record<CoolingCycle, string> = {
    [HeatCycle.IDLE]: 'idle',
    [CoolingCycle.PRIMING]: 'priming',
    [CoolingCycle.HEATING]: 'heating',
    [CoolingCycle.COOLDOWN]: 'cooldown',
    [CoolingCycle.CHILLING]: 'chilling',
};

export const ActiveCycleTextMap: Record<number, string> = isColdTub ? CoolingCycleTextMap : HeatCycleTextMap;
export const ActiveCycleStyleMap: Record<number, string> = isColdTub ? CoolingCycleStyleMap : HeatCycleStyleMap;